import React from "react";
import { GoogleLogin } from "@react-oauth/google";
import usePostData from "Hooks/usePostData";

const GoogleAuth = ({ onSuccess, onError }) => {
  const { postData } = usePostData();

  const handleGoogleSuccess = async (credentialResponse) => {
    const response = await postData("auth/google", {
      token: credentialResponse.credential,
    });

    if (response.success) {
      onSuccess(response);
    } else {
      onError?.(response.message);
    }
  };

  return (
    <div className="flex justify-center">
      <GoogleLogin
        onSuccess={handleGoogleSuccess}
        onError={() => onError?.("Google login failed")}
        theme="filled_black"
        size="large"
        width="100%"
        shape="pill"
      />
    </div>
  );
};

export default GoogleAuth;
